import { render } from "./whatsapp.vue?vue&type=template&id=344e5c52&scoped=true"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"

import "./whatsapp.vue?vue&type=style&index=0&id=344e5c52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344e5c52"]])

export default __exports__